import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, AlertColor, Button, Grid2 as Grid, Typography } from "@mui/material";
import { useLoginStatusStore } from "../../../../../config/user.stores";
import authService from "../../../../../services/auth.service";
import { FormTextField } from "../../../../../components/Shared/Form";
import { useTheme } from '@mui/material/styles';
import { statratRed } from '../../../../../config/constants';

type LoginType = {
    setIsLogin: (v: boolean) => void;
    isLoading: boolean;
    setIsLoading: (v: boolean) => void;
    registerSuccess: boolean;
    setRegisterSuccess: (v: boolean) => void;
}

const Login = ({ setIsLogin, isLoading, setIsLoading, registerSuccess, setRegisterSuccess }: LoginType) => {
    const theme = useTheme();
    const userLoggedIn = useLoginStatusStore((state) => state.userLoggedIn);
    const setUserLoggedIn = useLoginStatusStore((state) => state.setUserLoggedIn);
    let navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [alert, setAlert] = useState("");
    const [severity, setSeverity] = useState<AlertColor>("success");

    const handleLogin = (event: { preventDefault: () => void; }) => {
        event.preventDefault();
        setIsLoading(true);
        setRegisterSuccess(false);
        authService.login(email, password)
            .then(response => {
                setIsLoading(false);
                if (response.c === 1) {
                    setUserLoggedIn(true);
                    navigate("/");
                } else {
                    setSeverity("error");
                    setAlert(response.message);
                }
            });
    }

    function clearAlert() {
        setRegisterSuccess(false);
        setAlert("");
    }

    useEffect(() => {
        if (userLoggedIn) {
            navigate("/");
        }
    }, [userLoggedIn, navigate])

    useEffect(() => {
        if (!registerSuccess) {
            setAlert("");
        } else {
            setSeverity("success");
            setAlert("Account successfully created! Please login");
        }
    }, [email, password, registerSuccess])

    return (
        <>
        <Typography variant="h4">Login</Typography>
        <Grid container spacing={3} width={"100%"} component={"form"} onSubmit={handleLogin} sx={{
            input: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: `0 0 0 30px ${theme.palette.mode === "light" ? "white" :
                        "#121212"} inset !important;`
                }
            }
        }}>
            <FormTextField label="Email" value={email} setValue={setEmail} type="email" size={12} />
            <FormTextField label="Password" value={password} setValue={setPassword} type="password" size={12} />
            <Button
                variant="contained"
                size="large"
                disabled={!email || !password || isLoading}
                fullWidth
                type="submit"
            >
                Login
            </Button>
        </Grid>
        { alert !== "" && 
            <Alert severity={severity} variant="filled" sx={{ width: '100%' }} onClose={clearAlert}>{alert}</Alert>
        }
        <Typography>
            Don't have an account?
            <Button
                variant="text"
                sx={{ color: statratRed, backgroundColor: 'transparent' }}
                onClick={() => { setIsLogin(false) }}
            >
                Register
            </Button>
        </Typography>
        </>
    )
}

export default Login;
